/** Survives ClaimBadgesView mount timing so “Claim this badge” always opens Summarize. */
let pendingClaimBadgeId: string | null = null;

export const setPendingClaimBadgeId = (id: string | null): void => {
  pendingClaimBadgeId = id;
};

export const getPendingClaimBadgeId = (): string | null => pendingClaimBadgeId;
